// src/reducers/courses_reducer.js
import { RECEIVE_COURSE_DETAIL } from '../actions/courses_actions';

const initialState = {
  byKey: {},       // e.g. { ombre_powder_brows: { ...course+sections } }
  currentKey: null
};

const coursesReducer = (state = initialState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_COURSE_DETAIL: {
      const course = action.course;
      if (!course || !course.key) return state;
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [course.key]: course,
        },
        currentKey: course.key,
      };
    }

    default:
      return state;
  }
};

export default coursesReducer;
